import { defineComponent as _defineComponent } from 'vue'
import { Routes } from '@/router/routes';
import { Customer } from '@/models/tenant';
import { customersService } from '@/services/tenants.service';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { onBeforeMount, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import { useRouter } from '@/composables/router';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Overview',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const isLoading = ref(true);
const customers = ref<Customer[]>([]);

onBeforeMount(async () => {
  await getCustomers();
});

async function getCustomers() {
  customers.value = await customersService.get();
  isLoading.value = false;
}

function selectRow(data: Customer) {
  router.push({
    name: Routes.TechnologyConsoleTenantDevices,
    params: { tenantIdDh: data.tenantIdDh.toString() },
  });
}

return { __sfc: true,t, router, isLoading, customers, getCustomers, selectRow, TableWithActions }
}

})